import { render, staticRenderFns } from "./RecordCostUnitWorkshopInvoicePositions.vue?vue&type=template&id=074cff0e"
import script from "./RecordCostUnitWorkshopInvoicePositions.vue?vue&type=script&lang=js"
export * from "./RecordCostUnitWorkshopInvoicePositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports